import React from 'react';
import { Segment, Divider, Dimmer, Loader, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { GetDrivers, showCertificate } from './';
import { UserActions } from '../../actions';
import Moment from 'react-moment';

class Drivers extends React.Component {
    constructor(props) {
        super(props);
        let certificates = this.props.certificatesBD;
        this.state = {
            certificates,
            driverId: -1,
        };
        
        if (this.state.certificates === [] || !this.props.certificatesBDCreated) {

            this.props.dispatch(UserActions.get_certificates_bydriver(this.state.driverId));
        }

        this.getData = this.getData.bind(this);
        this.openPopup = this.openPopup.bind(this);
    }
    openPopup(index) {
        if (this.props.certificatesBD != [] && this.props.certificatesBD[index].DriverId && this.props.certificatesBD[index].Certificate) {
            this.props.dispatch(UserActions.get_ucertificate(this.props.certificatesBD[index].DriverId, this.props.certificatesBD[index].Certificate));
        }
    }
    getData(val) {
        this.setState({
            driverId: val
        });
        this.props.dispatch(UserActions.get_certificates_bydriver(val));
    }
    render() {
        return (
            <div>
                <Segment id='Egitimler' style={{ height: '50%' }}>
                    <div className='panel-pages-top' >
                        <h1 id='Egitimler'>Suruculer</h1>
                        <GetDrivers sendData = {this.getData} />
                    </div>
                    <Divider />
                    <Segment id='Egitimler-ic'>
                        {this.props.certificatesBDCreated && this.props.certificatesBD &&
                            <Table id='antiSkid' textAlign='center' style={{ background: 'rgba(255,255,255,0.12)' }}>
                                <Table.Header>
                                    <Table.Row>

                                        <Table.HeaderCell>Ad</Table.HeaderCell>
                                        <Table.HeaderCell>Soyad</Table.HeaderCell>
                                        <Table.HeaderCell>Tarih</Table.HeaderCell>
                                        <Table.HeaderCell>Sertifika</Table.HeaderCell>
                                        <Table.HeaderCell>Toplam Puan</Table.HeaderCell>
                                        <Table.HeaderCell>Goruntule</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                {getCertificates.bind(this)()}
                            </Table>
                        }
                        {this.props.certificatesBDCreating &&
                            <Dimmer active style={{ background: 'rgba(0,0,0,0)' }}>
                                <Loader />
                            </Dimmer>
                        }
                    </Segment>
                </Segment>
            </div>
        );
    }
}

function getCertificates() {
    let certificates = this.props.certificatesBD;
    return certificates.map((certificate, index) => (
        <Table.Row>
            <Table.Cell>{certificate.Name}</Table.Cell>
            <Table.Cell>{certificate.Surname}</Table.Cell>
            <Table.Cell><Moment unix format="DD/MM/YYYY">{certificate.EvaluationDate/1000}</Moment></Table.Cell>
            <Table.Cell>{certificate.Certificate}</Table.Cell>
            <Table.Cell>{certificate.TotalPoint}</Table.Cell>
            <Table.Cell>{showCertificate.bind(this)(index, this.props.certificatesBD[index].Certificate)}</Table.Cell>
        </Table.Row>
    ));
}
function mapStateToProps(state) {
    const { certificatesBD, certificatesBDCreated, certificatesBDCreating } = state.certificatesBD;
    const { certificateDetails, detailsExists, detailsLoading } = state.certificateDetails;
    return {
        certificatesBD,
        certificatesBDCreated,
        certificatesBDCreating,
        certificateDetails,
        detailsExists,
        detailsLoading,
    };
}
const connectedDrivers = connect(mapStateToProps)(Drivers);
export { connectedDrivers as Drivers }; 


// WEBPACK FOOTER //
// ./src/components/PanelPages/Drivers.jsx